export default "__VITE_ASSET__a9d9df96__"